import React from 'react';

// Supermove

// App
import MultiEntryFieldInput from '@shared/design/components/Field/MultiEntryFieldInput';
import {FormikSetupCallrailIntegrationFormType} from '@shared/modules/CallrailIntegration/forms/SetupCallrailIntegrationForm';

interface CallrailExcludedPhoneNumbersFieldsProps {
  form: FormikSetupCallrailIntegrationFormType;
  field: string;
}

const CallrailExcludedPhoneNumbersFields = ({
  form,
  field,
}: CallrailExcludedPhoneNumbersFieldsProps) => {
  const {errors} = form;
  const fieldPath = `${field}.callrailExcludedPhoneNumbers`;
  const fieldError = errors[fieldPath];

  return (
    <React.Fragment>
      <MultiEntryFieldInput
        form={form}
        field={fieldPath}
        label={'Phone Numbers'}
        placeholder='Enter phone number (10 digits)'
        tooltip='Enter a 10-digit phone number with no spaces or special characters'
      />
    </React.Fragment>
  );
};

export default CallrailExcludedPhoneNumbersFields;
